import { useEffect, useState } from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { toast } from "react-toastify";

import CategoryFormModal from "./CategoryFormModal";
import PrimaryButton from "../../components/PrimaryButton";
import { ReactComponent as EditIcon } from "../../static/icons/edit.svg";
import useWindowDimensions from "../../utils/hooks/getWindowDimensions";
import { ReactComponent as DeleteIcon } from "../../static/icons/delete-icon.svg";
import Table from "../../components/Table";
import { deleteCategory, getCategories } from "../../services/CategoryService";
import { getCurrentUser } from "../../utils/utils";
import SecondaryButton from "../../components/SecondaryButton";

const CategoryList = () => {
  const [categories, setCategories] = useState([]);
  const [formOpen, setFormOpen] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const { width } = useWindowDimensions();
  const user = getCurrentUser();

  useEffect(() => {
    getCategories(`created_by=${user.id}`).then((data) => setCategories(data));
  }, []);

  const onDelete = (item) => {
    deleteCategory({ id: item.id }).then(() => {
      setCategories((oldVal) =>
        oldVal.reduce((acc, i) => {
          if (i.id !== item.id) {
            acc.push(i);
          }
          return acc;
        }, [])
      );
      toast.success(`The category ${item.name} has been deleted.`);
    });
  };

  const columns = [
    {
      label: "Name",
      name: "name",
    },
    {
      label: "Color",
      name: "color",
      component: (item) => (
        <div className="color" style={{ background: item?.color }}>
          {!item.color ? "X" : ""}
        </div>
      ),
    },
    {
      hidden: true,
      type: "button",
      name: "edit-btn",
      component: (item) =>
        width < 600 ? (
          <EditIcon
            onClick={() => {
              setEditItem({ ...item, color: { hex: item.color } });
              setFormOpen(true);
            }}
          />
        ) : (
          <SecondaryButton
            onClick={() => {
              setEditItem({ ...item, color: { hex: item.color } });
              setFormOpen(true);
            }}
          >
            Edit
          </SecondaryButton>
        ),
    },
    {
      hidden: true,
      type: "button",
      name: "delete-btn",
      component: (item) =>
        width < 600 ? (
          <DeleteIcon onClick={() => onDelete(item)} />
        ) : (
          <SecondaryButton onClick={() => onDelete(item)}>
            Delete
          </SecondaryButton>
        ),
    },
  ];

  return (
    <Container fluid>
      <Row>
        <Table
          columns={columns}
          data={categories}
          header={
            <Container style={{ margin: "13px 13px 25px" }}>
              <Row>
                <Col>
                  <h5 className="vertical-align-text table-title">
                    Work Types - Categories of work
                  </h5>
                </Col>
                <Col>
                  <PrimaryButton
                    onClick={() => setFormOpen(true)}
                    style={{ float: "right" }}
                  >
                    Add +
                  </PrimaryButton>
                </Col>
              </Row>
            </Container>
          }
        />
      </Row>
      <CategoryFormModal
        open={formOpen}
        onClose={() => {
          setEditItem(null);
          setFormOpen(false);
        }}
        setCategories={setCategories}
        data={editItem}
      />
    </Container>
  );
};

export default CategoryList;
